import React from 'react';
import styled from 'styled-components';
import { fontFamilies } from '../../../helpers/fonts';
import { Item, ItemProps } from './Item';

export const ItemMinimalistic: React.FC<ItemProps> = props => {
  return <Item {...props} />;
};

export const CircleBullet = styled.div.attrs({ className: 'icb' })<{ backgroundColor?: string }>`
  ${({ backgroundColor }) => (backgroundColor ? `background-color: ${backgroundColor}` : '')};
  width: 12px;
  height: 12px;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(153, 153, 153);
  border-radius: 50%;
  margin-top: 1px;
  margin-right: 6px;
`;

ItemMinimalistic.defaultProps = {
  bullet: { regular: <CircleBullet />, selected: <CircleBullet backgroundColor={'black'} /> },
  fontConfig: {
    fontFamily: fontFamilies.light,
    fontSize: '13px',
  },
  hover: {
    textDecoration: 'underline',
  },
};
